import React from 'react';
import { Icon } from '@shoflo-rundown/polymer.legacy';
import CuesheetRowActions from 'flux/actions/cuesheet/CuesheetRowActions';
import KeyBindingActions from 'flux/actions/KeyBindingActions';

let escaped = false;

const Proof = React.createClass({
  getInitialState() {
    return { focus: false };
  },

  componentWillReceiveProps({ note }) {
    if (!note && !this.state.focus) {
      return this.setState({ value: '' });
    }
    // only update if the user doesn't have the textarea focused
    if (note !== this.props.note && !this.state.focus) {
      this.setState({ value: note });
    }
  },

  render() {
    const { hover, note } = this.props;
    const { focus, value } = this.state;

    const placeholder = hover && !focus ? 'Add Note (20 chars)' : '';

    return (
      <div className="cs-proof-note">
        {!note && !value && hover && !focus ? (
          <Icon name="pencil-square-o" />
        ) : null}
        <textarea
          data-testid="proof-text-input"
          type="text"
          placeholder={placeholder}
          defaultValue={note}
          value={value}
          rows={1}
          cols={20}
          maxLength={20}
          onChange={this._onNoteChange}
          onKeyDown={this._onKeyDown}
          onFocus={this._onFocus}
          onBlur={this._onBlur}
        />
        <div tabIndex={0} />
      </div>
    );
  },

  _onKeyDown(e) {
    if (e.key === 'Escape' || e.keyCode === 27) {
      this.setState({ value: this.props.note });
      escaped = true;
      return e.currentTarget.blur();
    }
  },

  _onNoteChange(e) {
    if (e.target.value.indexOf('\n') >= 0) {
      e.preventDefault();
      return;
    }
    this.setState({ value: e.target.value });
  },

  _onFocus() {
    KeyBindingActions.unbindHotKeys();
    KeyBindingActions.unbindNavigationKeys();
    this.setState({ focus: true });
  },

  _onBlur(e) {
    // if user exits input with the escape key, do not save the change
    if (!escaped) {
      CuesheetRowActions.updateItemRowProofNote(
        this.props.rowIndex,
        e.target.value,
      );
    }
    escaped = false;

    KeyBindingActions.bindHotKeys();
    KeyBindingActions.bindNavigationKeys();
    this.setState({ focus: false });
  },
});

export default Proof;
